import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import store from './core/services/store';
import AntdProvider from './providers/AntdProvider';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { platformConfig } from './core/config/platform';

document.documentElement.style.setProperty('--primary-color', platformConfig.primaryColor);
document.documentElement.style.setProperty('--primary-color-light', platformConfig.primaryColorLight);
document.documentElement.style.setProperty('--banner-bg', `url(${platformConfig.bannerBg})`);
document.title = platformConfig.appTitle;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <AntdProvider>
        <App />
        <ToastContainer/>
      </AntdProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
